import React from "react";
import {
  addElement,
  setOnPremiseState,
} from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import Levels from "./ConfidentialityLevels";
import InfoTooltip from "../../formFields/InfoTooltip";
import ExternalCollaboration from "./ExternalCollaboration";
import Warning from "../CommonComponents/Warning";
import MessageForPGUsers from "../CommonComponents/MessageForPGUsers";

class ConfidentialityLevel extends React.Component {
  render() {
    const toolTipContent = (
      <span>
        <a
          href="https://accelleronindustries.sharepoint.com/sites/Turbo-Policy/_layouts/15/DocIdRedir.aspx?ID=POLICY-1529498466-85"
          target="_blank"
          rel="noopener noreferrer">
          ITPO-0016 Information Classification and Handling
        </a>
      </span>
    );

    const warning =
      this.props.possibleWarning && !this.props.confidentiality ? (
        <Warning element="" />
      ) : null;

    const levels = (
      <Levels
        level={this.props.confidentialLevel}
        pgEmployee={this.props.currentUser.pgEmployee}
      />
    );
    return (
      <div className="wizard-inside">
        <div className="item-title">
          Select confidentiality level
          <InfoTooltip content={toolTipContent} />
          {warning}
        </div>
        {levels}
        <MessageForPGUsers pgEmployee={this.props.currentUser.pgEmployee} />
        <ExternalCollaboration />
      </div>
    );
  }
}
const mapActionsToProps = {
  sendElement: addElement,
  setOnpremise: setOnPremiseState,
  //  updateValidationStatus: updateValidationStatus
};
const mapStateToProps = (state) => ({
  confidentiality: state.newSite.Confidentiality,
  possibleWarning: state.wizard.nextStepRequested,
  currentUser: state.user.currentUser,
  isIATU: state.newSite.isIATU,
  isIAPCP: state.newSite.isIAPCP,
});

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ConfidentialityLevel);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/Confidentiality.js